module.exports = __webpack_public_path__ + "static/media/volume2.a71d37e3.svg";